import Block from '../../common.blocks/block'

export default class CheckoutProduct extends Block {
	static title = 'checkout-product'

	constructor($el) {
		super($el)

		this.deleteButton = this.$el.findElement('button--delete')

		if (this.deleteButton) {
			this.deleteButton.on('click', () => {
				this.removeItem(this.$el.data('productId'))
			})
		}
	}

	removeItem(id) {
		const url = '/checkout/delete/' + id

		$(document).trigger('shoppingcart:remove-from-cart', id)

		$.ajax({
			url: url,
			method: 'DELETE',
			success: function () {
				window.location.reload()
			},
			error: function () {
				//
			},
		})
	}
}
